import { $http } from '@/plugins/common/http';

export const getMaintenanceList = () => {
    return $http.get('maintenance');
};
